// jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('foundation-sites');

window.axios = require('axios');

$(document).foundation();

// Owl carousel
require('owl.carousel');

require('jquery-touch-events');
require('lightcase');


document.addEventListener('swipeleft', function(e) {
    e.preventDefault();
    var touch = e.touches[0];
    alert(touch.pageX + " - " + touch.pageY);
}, false);




// WEBPACK FOOTER //
// ./scripts/bootstrap.js